(() => {
  const header = document.querySelector('[data-gallery-header]');
  if (!header) return;
  const menus = [...header.querySelectorAll('.rv-menu, .rv-market')];
  header.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = menus.find((menu) => menu.open && menu.contains(event.target));
    if (open) {
      open.open = false;
      open.querySelector('summary').focus();
    }
  });
  menus.forEach((menu) => menu.addEventListener('toggle', () => {
    if (menu.open) menus.filter((other) => other !== menu).forEach((other) => { other.open = false; });
  }));
  document.addEventListener('click', (event) => {
    menus.forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
